module.exports = __webpack_public_path__ + "img/grande.314891fa.jpg";